/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Remix } from './Remix';
import {
    RemixFromJSON,
    RemixFromJSONTyped,
    RemixToJSON,
} from './Remix';

/**
 * 
 * @export
 * @interface RemixParent
 */
export interface RemixParent {
    /**
     * 
     * @type {Array<Remix>}
     * @memberof RemixParent
     */
    tracks?: Array<Remix>;
}

/**
 * Check if a given object implements the RemixParent interface.
 */
export function instanceOfRemixParent(value: object): value is RemixParent {
    let isInstance = true;

    return isInstance;
}

export function RemixParentFromJSON(json: any): RemixParent {
    return RemixParentFromJSONTyped(json, false);
}

export function RemixParentFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixParent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tracks': !exists(json, 'tracks') ? undefined : ((json['tracks'] as Array<any>).map(RemixFromJSON)),
    };
}

export function RemixParentToJSON(value?: RemixParent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tracks': value.tracks === undefined ? undefined : ((value.tracks as Array<any>).map(RemixToJSON)),
    };
}

